import { Router } from '@angular/router';
import { CompteServer } from '../../Model/CompteServer';
import { ServiceAdminService } from '../../Providers/service-admin.service';
import { Component, OnInit } from '@angular/core';


/**
 * created by AHMED HAYEL
 * 
 */

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  constructor(private service: ServiceAdminService, private router: Router) { }

  ngOnInit() {

    if (this.service.isAuthenticated == false) {
      this.router.navigate(['/error']);
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/admin-component/dashboard/dashboard.component.ts